var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StyledIcon } from '../components/StyledIcon';
export var Asset = forwardRef(function (props, ref) { return (_jsx(StyledIcon, __assign({ ref: ref, viewBox: "0 0 30 30", a11yTitle: "Asset" }, props, { children: _jsx("path", { d: "M11.4472 4.33813V5.5153H5.56137C4.2606 5.5153 3.20703 6.56887 3.20703 7.86964V10.224H26.7504V7.86964C26.7504 6.56887 25.6968 5.5153 24.396 5.5153H18.5102V4.33813H11.4472ZM3.20703 12.5783V21.9956C3.20703 23.2941 4.26295 24.35 5.56137 24.35H24.396C25.6945 24.35 26.7504 23.2941 26.7504 21.9956V12.5783H23.2189V13.7555H18.5102V12.5783H11.4472V13.7555H6.73853V12.5783H3.20703Z", fill: "#000" }) }))); });
//# sourceMappingURL=Asset.js.map